<script setup>
require("dotenv").config();
import { ref, computed } from 'vue';
import Layout from "@/layouts/main.vue";
import PageHeader from "@/components/page-header";
import '@jobinsjp/vue3-datatable/dist/style.css';
import { DataTable, TableBody, TableHead, TableBodyCell } from '@jobinsjp/vue3-datatable';
import store from '../../state/store';
import axios from 'axios';
import { authHeader } from '../../helpers/authservice/auth-header';
import Swal from 'sweetalert2';

const backend_url = process.env.VUE_APP_BASE_URL || "http://main-backend.qpax.ph";
const file = ref('');
const isUploaded = ref(false);
const isProcessed = ref(false);
const uploadedBulkFile = ref('');
// const validRecordsPagination = ref({
//   per_page: 1000,
//   total: 0,
//   page: 1
// });
// const invalidRecordsPagination = ref({
//   per_page: 1000,
//   total: 0,
//   page: 1
// });
const validRecords = ref([]);
const invalidRecords = ref([]);
const loading = computed(() => store.state.globals.loading);
const title = ref('Bulk Void');
const items = ref([
    {
      text: "Home",
    },
      {
      text: "Traffic Records",
    },
    {
      text: "Bulk Void",
      active: true,
    },
]);
const handleUploadBulkFile = () => {
  uploadedBulkFile.value = file.value.files[0];
  if (typeof uploadedBulkFile.value === 'undefined') return;

  uploadingBulkFile();
}

const uploadingBulkFile = async () => {
  validRecords.value = [];
  invalidRecords.value = [];

  store.dispatch('globals/loading', null, { root: true });

  try {
    const formData = new FormData();
    formData.append('from_excel', uploadedBulkFile.value);
    const { data } = await axios.post('void/load-excel-file', formData, {
      headers: authHeader()
    })

    validRecords.value = !data.valid ? [] : data.valid;
    invalidRecords.value = !data.no_record ? [] : data.no_record;

    isUploaded.value = true;
    isProcessed.value = false;

    file.value.value = '';
    store.dispatch('globals/loaded', null, { root: true });
  } catch (err) {
    console.log(err);
    isUploaded.value = false;
    store.dispatch('globals/loaded', null, { root: true });
  }
}

const processBulkFile = async () => {
  if (!validRecords.value.length) return;

  const confirm = await Swal.fire({
    icon: 'warning',
    title: 'Continue?',
    text: 'Do you want to proceed to void traffic records?',
    showCancelButton: true,
    confirmButtonText: 'Yes',
  })
  if (!confirm.isConfirmed) {
    return;
  }

  store.dispatch('globals/loading', null, { root: true });

  try {
    const formData = new FormData();
    formData.append('from_excel', uploadedBulkFile.value);
    const { data } = await axios.post('void/bulk', formData, {
      headers: authHeader()
    });

    validRecords.value = !data.data.voided ? [] : data.data.voided;
    invalidRecords.value = !data.data.no_record ? [] : data.data.no_record;

    isUploaded.value = true;
    isProcessed.value = true;
    file.value.value = '';
    store.dispatch('globals/loaded', null, { root: true });

    Swal.fire(
      "Voided", 
      `Successfully voided traffic records`, 
      "success"
    );
  } catch (err) {
    console.log(err);
    isProcessed.value = false;
    store.dispatch('globals/loaded', null, { root: true });
  }
}
</script>

<template>
  <Layout>
    <PageHeader :title="title" :items="items" />
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12 col-lg-6 col-xl-5 col-xxl-3">
            <div class="card">
              <div class="card-header">
                  <h4 class="card-title">Bulk Upload of Void Traffic Records</h4>
                    <div class="text-muted fs-11 text">Download the template format for the bulk voiding. 
                      Paste the NOV # of the record that needs to be voided. Upload the excel. Then click process</div>
              </div>
              <div class="card-body">
                <form action="javascript:void(0);">
                  <div class="row">
                    <div class="col-12">
                      <div class="mb-3">
                        <label class="form-label d-block">Download Template</label>
                        <a :href="`${backend_url}/docs-template/Void_format.xlsx`" class="btn btn-success">
                          <i class="mdi mdi-microsoft-excel align-middle mr-1 fs-5 text-white"></i>
                          Download Template
                        </a>
                      </div>
                    </div>
                    <div class="col"><hr></div>
                    <div class="col-12">
                      <div class="mb-3">
                        <label class="form-label d-block">Upload File (.xlsx)</label>
                        <label class="btn btn-info mb-2">
                          <i class="mdi mdi-upload align-middle mr-1 fs-5 text-white"></i>
                          Upload Bulk Void (Excel)
                          <input type="file" @change="handleUploadBulkFile" ref="file" name="uploadBulkFile" class="d-none">
                        </label>
                      </div> 
                    </div>
                  </div>
                </form>
              </div>
            </div>  
        </div>
        <div class="col-md-12 col-lg-6 col xl-7 col-xxl-9">
          <b-overlay :show="loading">
            <div class="card">
              <template v-if="isUploaded">
                <div class="card-header">
                  <h4 class="card-title text-success">Valid Records found: {{ validRecords.length ? validRecords.length : 0  }}</h4>
                </div>
                <div class="card-body">
                  <data-table :rows="validRecords"
                      striped
                      :loading="loading"
                      hoverable
                      sortable
                  >
                    <template #thead>
                        <table-head>NOV #</table-head>
                        <table-head>Note/Reason</table-head>
                        <table-head>Status/Response</table-head>
                    </template>

                    <template #tbody="{row}">
                        <table-body v-text="row.nov"/>
                        <table-body v-text="row.reason" />
                        <table-body>
                          <b-badge :variant="isProcessed ? 'success' : 'secondary'">
                            {{ isProcessed ? 'Valid' : 'Pending' }}
                          </b-badge>
                        </table-body>
                    </template>

                    <template #empty>
                      <TableBodyCell colspan="3">
                          No valid records found!
                      </TableBodyCell>
                    </template>
                  </data-table>
                  <div class="d-flex justify-content-end mb-3">
                    <button @click="processBulkFile" :disabled="!validRecords.length" class="btn btn-primary">
                      <i class="mdi mdi-upload align-middle mr-1 fs-5 text-white"></i>
                      Process
                    </button>
                  </div>
                </div>
              </template>
              <template v-if="isUploaded">
                <div class="card-header">
                  <h4 class="card-title text-danger">Invalid Records found: {{ invalidRecords.length ? invalidRecords.length : 0 }}</h4>
                </div>
                <div class="card-body">
                  <data-table :rows="invalidRecords"
                      striped
                      :loading="loading"
                      hoverable
                      sortable
                  >
                    <template #thead>
                        <table-head>NOV #</table-head>
                        <table-head>Status/Response</table-head>
                    </template>

                    <template #tbody="{row}">
                        <table-body v-text="row.nov"/>
                        <table-body>
                          <b-badge variant="danger">
                            Invalid
                          </b-badge>
                        </table-body>
                    </template>

                    <template #empty>
                      <TableBodyCell colspan="2">
                          No invalid records so far!
                      </TableBodyCell>
                    </template>
                  </data-table>
                </div>
              </template>
              <template v-if="!isUploaded">
                <div class="card-body">
                  <div class="text-center">
                    <div class="row justify-content-center">
                      <div class="col-lg-9">
                        <h2 class="mt-4 fw-semibold">Bulk Void</h2>
                        <p class="text-muted mt-3 fs-20">
                          Uploaded file data will show up here
                        </p>
                      </div>
                    </div>
                    <div class="row justify-content-center mt-5 mb-2">
                      <div class="col-sm-7 col-8">
                        <img src="@/assets/images/file.png" alt="" class="img-fluid">
                      </div>
                    </div>
                  </div>
                </div>
              </template>
            </div>
          </b-overlay>
        </div>
      </div>
    </div>
  </Layout>
</template>